import { render, staticRenderFns } from "./DzdgPage.vue?vue&type=template&id=dabdd5f2&scoped=true"
import script from "./DzdgPage.vue?vue&type=script&lang=js"
export * from "./DzdgPage.vue?vue&type=script&lang=js"
import style0 from "./DzdgPage.vue?vue&type=style&index=0&id=dabdd5f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dabdd5f2",
  null
  
)

export default component.exports